<template>
  <component v-if="css || mobile" :is="tag || 'div'" class="mobile-only">
    <slot />
  </component>
</template>

<script setup lang="ts">
defineProps<{
  tag?: string;
  css?: boolean;
}>();

const { mobile } = useBreakpoints();
</script>

<style scoped>
@media (min-width: 850px) {
  .mobile-only {
    display: none;
  }
}
</style>